module.exports = __webpack_public_path__ + "assets/img/driver-btn-4698ac9b.png";